import { isString, isUndefined } from "lodash";

export function isEmpty(value) {
    return isUndefined(value) || value === null || (isString(value) && value.trim() === '') || value === false || (Array.isArray(value) && value.length === 0 );
}
